module.exports = __webpack_public_path__ + "img/hydrologiskedata.0841e29b.jpg";